import { registerSettingsCard } from '../../components/SettingsCards';
import type { ModuleRoute } from '../types';
import { BadgeSettingsCard } from './BadgeSettingsCard';
import { DesignerPage } from './DesignerPage';
import { TemplatesPage } from './TemplatesPage';

registerSettingsCard('badges', BadgeSettingsCard);

/** Pages of this area. Owned by Phase 1 task W6; only that task edits files in this folder. */
export const routes: ModuleRoute[] = [
  { path: '/manage/badges', element: <TemplatesPage />, permission: 'sites.view' },
  { path: '/manage/badges/:id', element: <DesignerPage />, permission: 'sites.view' },
];
